import getUrlPath from '../../utils/getUrlPath';
import ViewOnScreen from '../../components/view-on-screen/ViewOnScreen';
import { AreaThree, ExternalIcon, Link, LinkIcon, Links, MenuTitle, RightBorder, Separator } from './Style';
import { FormattedMessage } from 'react-intl';
import { url } from '../../constants/url';

function RentalMenuLinks() {  
  return (
    <AreaThree>
      <Links>
        <MenuTitle>
          <FormattedMessage id={'userDropdown.subtitles.rentalAccount'} />
        </MenuTitle>

        <Link href={getUrlPath(url.account.id)}>
          <FormattedMessage id={'userDropdown.links.account'} />
        </Link>

        <ViewOnScreen screen={{ up: 'xs' }}>
          <Link
            href={getUrlPath(url.estrack.subPath.billing.id)}
            target='_blank'
          >
            <FormattedMessage id={'userDropdown.links.invoices'} />
            <LinkIcon>
              <ExternalIcon />
            </LinkIcon>
          </Link>
        </ViewOnScreen>

        <ViewOnScreen screen={{ down: 'xs' }}>
          <Link href={getUrlPath(url.account.subPath.profile.id)}>
            <FormattedMessage id={'userDropdown.links.myProfile'} />
          </Link>
        </ViewOnScreen>

        <ViewOnScreen screen={{ down: 'xs' }}>
          <Link
            href={getUrlPath(url.estrack.subPath.billing.id)}
            target='_blank'
          >
            <FormattedMessage id={'userDropdown.links.invoices'} />
            <LinkIcon>
              <ExternalIcon />
            </LinkIcon>
          </Link>
        </ViewOnScreen>

        <Link href={getUrlPath(url.estrack.subPath.help.id)}>
          <FormattedMessage id={'userDropdown.links.helpCenter'} />
        </Link>

        <ViewOnScreen screen={{ down: 'xs' }}>
          <Separator mt={16} mb={6} />
        </ViewOnScreen>
      </Links>
      <RightBorder/>
    </AreaThree>
  );
}

export default RentalMenuLinks;
